import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiField, SuiTab, SuiTabs, SuiContainer } from '@splashthat/sui';

const valuePropTypes = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

const StyledTabs = styled(SuiTabs)`
    display: flex;
    justify-content: space-around;
`;

const FormStyleTabsSelector = (props) => (
    <SuiField
        fullWidth
        formElement={
            <SuiContainer variation="full-width">
                <StyledTabs
                    className="FormStyleTabsSelector__container"
                    noActiveBar
                    fullWidth
                    onChange={(event, val) => props.onChange(val)}
                    value={props.value}
                    size="small"
                >
                    {props.tabs.map((customTab, index) => (
                        <SuiTab
                            iconBefore={customTab.icon}
                            value={customTab.value}
                            title={customTab.label}
                            label={customTab.label}
                            key={index}
                            iconDirection="column"
                        />
                    ))}
                </StyledTabs>
                {props.customName && props.customName === props.value && props.children}
            </SuiContainer>
        }
    />
);

FormStyleTabsSelector.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
            label: PropTypes.string,
            value: valuePropTypes,
        }),
    ),
    value: valuePropTypes,
    onChange: PropTypes.func.isRequired,
    customName: PropTypes.string,
    children: PropTypes.node,
};

FormStyleTabsSelector.defaultProps = {
    tabs: [],
    value: null,
    customName: null,
    children: null,
};

export default FormStyleTabsSelector;
